import React from 'react'
import { Select } from "antd";
import Utils from "Utils";
const { Option } = Select

export function AntSelect({
    dataSource,
    fieldName,
    value,
    displayExpr,
    valueExpr,
    setFieldValue,
    isRequired = false,
    label = null,
    touched = {},
    errors = {},
    options = {},
    onChange = null,
}) {
    return (
        <div className="custom-field flex flex-column">

            <div className={`label ${isRequired && 'required'}`}>{label || Utils.convertSnakeCaseToSpace(fieldName)}</div>
            <Select name={fieldName} onChange={(e) => {
                setFieldValue(fieldName, e);
                if (onChange) onChange(e);
            }} value={value} {...options}>
                {(displayExpr || valueExpr) ? dataSource.map(data => {
                    return <Option title={data[displayExpr]} value={data[valueExpr]}>{data[displayExpr]}</Option>
                }) : <>
                    {(dataSource || []).map(data => {
                        return <Option title={data} value={data} />
                    })}
                </>}
            </Select>
            <div className="error">
                {errors[fieldName] && touched[fieldName] && errors[fieldName]}
            </div>
        </div>

    )
}
